@if (isLoading) {
  <div class="fx-col-h-100 fx-center fx-h-center">
    <mat-card style="width: 600px">
      <mat-card-content>
        <app-processing-dialog></app-processing-dialog>
      </mat-card-content>
    </mat-card>
  </div>
} @else {
  <router-outlet></router-outlet>
}
